module.exports = __webpack_public_path__ + "entry-150bfe9b/db-photo-02549d164a10db0a6f23f0f7490127d6.webp";